const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M413.656,34.344l-32-32C380.156,0.844,378.122,0,376,0H72c-4.418,0-8,3.582-8,8v432c0,2.122,0.844,4.156,2.344,5.656 l32,32c1.5,1.5,3.534,2.344,5.656,2.344h304c4.418,0,8-3.582,8-8V40C416,37.878,415.156,35.844,413.656,34.344z M312,27.312 L388.688,104H312V27.312z M400,464H107.312L80,436.688V16h216v96c0,4.418,3.582,8,8,8h96V464z M400,92.688L323.312,16h49.376 L400,43.312V92.688z"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,136H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,136,344,136z"
})));
var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,184H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,184,344,184z"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,232H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,232,344,232z"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,280H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,280,344,280z"
})));
var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,328H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,328,344,328z"
})));
var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M344,376H136c-4.418,0-8,3.582-8,8s3.582,8,8,8h208c4.418,0,8-3.582,8-8S348.418,376,344,376z"
})));
var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M240,56c-17.673,0-32,14.327-32,32s14.327,32,32,32c17.673,0,32-14.327,32-32S257.673,56,240,56z M240,104 c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S248.837,104,240,104z"
})));
var _ref0 = /*#__PURE__*/React.createElement("g", null);
var _ref1 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
var _ref16 = /*#__PURE__*/React.createElement("g", null);
var _ref17 = /*#__PURE__*/React.createElement("g", null);
var _ref18 = /*#__PURE__*/React.createElement("g", null);
var _ref19 = /*#__PURE__*/React.createElement("g", null);
var _ref20 = /*#__PURE__*/React.createElement("g", null);
var _ref21 = /*#__PURE__*/React.createElement("g", null);
var _ref22 = /*#__PURE__*/React.createElement("g", null);
function SvgSecurityDetailsDownloadTermsheet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityDetailsDownloadTermsheet);
export default __webpack_public_path__ + "static/media/security-details-download-termsheet.960e7442c9b8e87bdbcd49f99da1ffd2.svg";
export { ForwardRef as ReactComponent };